import React from 'react';
import { ConfirmDialog } from '@shared/components/confirmDialog/ConfirmDialog';
import { useBlocker } from './useBlocker';
import { useConfirmDialog } from './useConfirmDialog';

type Params = {
  isBlocked: boolean;
  titleKey: string;
  message: string;
};

export const RouterBlockerDialog: React.FC<Params> = ({ isBlocked, titleKey, message }) => {
  const { confirm, dialogProps } = useConfirmDialog(isBlocked);
  useBlocker(isBlocked, confirm);

  return (
    <ConfirmDialog
      {...dialogProps}
      dialogTitle={titleKey}
      dialogContentText={message}
      variant="warning"
    />
  );
};
